import Header from './components/Header';
import HeroSection from './components/HeroSection';
import OpeningSection from './components/OpeningSection';
import StorySection from './components/StorySection';
import ProofSection from './components/ProofSection';
import TestimonialsSection from './components/TestimonialsSection';
import WhatIsSection from './components/WhatIsSection';
import WhyNowSection from './components/WhyNowSection';
import ContactForm from './components/ContactForm';
import CompanyInfo from './components/CompanyInfo';
import Footer from './components/Footer';

export default function HomePage() {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <HeroSection />
      <OpeningSection />
      <StorySection />
      <ProofSection />
      <TestimonialsSection />
      <WhatIsSection />
      <WhyNowSection />
      <ContactForm />
      <CompanyInfo />
      <Footer />
    </div>
  );
}
